import { useMutation } from "react-query";
import { addCameraType2 } from "../../../../../actions/Utilities/CameraType2";
import { ICameraType2 } from "../types";
import { toast } from "components/toastNotification";
import { useRecoilState, useSetRecoilState } from "recoil";
import { addStateCameraType2, cameraType2ReFetching } from "../atoms/atoms";

const useAddCameraType2 = () => {
  const setActionAddState = useSetRecoilState(addStateCameraType2);
  const [isReFetching, setIsReFetching] = useRecoilState(cameraType2ReFetching);
  const { mutate } = useMutation(
    (NewData: ICameraType2) => addCameraType2(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Camera Type 2 failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Camera Type 2 Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Camera Type 2 Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Camera Type 2 failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Camera Type 2 failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Adding Camera Type 2 failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Camera Type 2 failed", res, "error");
          }
        }
        // Redirect to View
        setActionAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Camera Type 2 failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddCameraType2;
